import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import BreakersBg from "images/breakers_pic.png";
import FlexGridChart from "images/CHART_5.png";

export const FlexibleMicroGrid = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        align-items: flex-start;
      }
      @media screen and (min-width: ${getSize(
          "tablet960"
        )}) and (max-width: 1199px) {
        padding-right: 50px;
      }
      @media screen and (min-width: ${getSize("tablet960")}) {
        align-items: center;
        flex-direction: row-reverse;
        justify-content: space-between;
      }
      @media screen and (min-width: ${getSize(
          "desktop1200"
        )}) and (max-width: 1919px) {
        padding-right: 76px;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query FlexibleMicroGridHeroImageQuery {
          file(relativePath: { eq: "breakers_pic.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt="savant power breakers and modules"
          css={`
            + picture > img,
            img {
              object-position: 80% 50%;
              /* position: relative; */
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 56% 50%;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: 57% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <img
      alt="flexible electrical grid diagram"
      css={`
        bottom: 0;
        height: 291px;
        left: 0;
        margin: auto;
        object-fit: contain;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateY(-50%);
        width: 295px;
        @media screen and (min-width: ${getSize("mobile480")}) {
          height: 366px;
          transform: translateY(-40%);
          width: 368px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          bottom: 6%;
          height: 399px;
          top: unset;
          transform: unset;
          width: 401px;
        }
        @media screen and (min-width: ${getSize(
            "tablet768"
          )}) and (max-width: 959px) {
          bottom: 6%;
          height: 451px;
          width: 453px;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
          height: 402px;
          margin: 0;
          object-position: 100% 50%;
          position: static;
          transform: unset;
          width: 404px;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          height: 496px;
          object-position: 90% 50%;
          width: 498px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          height: 768px;
          object-position: 84% 50%;
        }
      `}
      src={FlexGridChart}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 31px 46px 46px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 767px) {
          padding: 40px 42px 45px 50px;
          width: 392px;
        }
        @media screen and (min-width: ${getSize(
            "tablet768"
          )}) and (max-width: 959px) {
          padding: 42px 42px 47px 50px;
          width: 400px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          width: 430px;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          padding: 39px 48px 44px 50px;
          width: 480px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          margin-top: -26px;
          padding: 68px 70px 74px 70px;
          width: 606px;
        }
      `}
    >
      <Header2>
        {"Flexible Microgrid"}
        <Underlined
          css={`
            @media screen and (min-width: ${getSize("desktop1200")}) {
              margin-top: 24px;
            }
            @media screen and (min-width: ${getSize("desktop1920")}) {
              margin-top: 18px;
            }
          `}
        />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: ${getSize("mobile480")}) {
            margin-top: 20px;
          }
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 767px) {
            margin-top: 14px;
            width: 296px;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            width: 301px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            width: 333px;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            width: auto;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            margin-top: 18px;
          }
        `}
      >
        {
          "By combining on-site energy generation, battery storage and Flexible Load Management our customers have complete control over their energy assets. A Savant Power Microgrid puts the power back in the hands of the consumer."
        }
      </Paragraph>
    </Card>
  </Section>
);
